export const kategori_rekomendasi = {
  router: [
    {
      name: "KATEGORI REKOMENDASI",
      key: "kategori_rekomendasi",
      path: "/admin/master/kategori-rekomendasi",
      apiUrl: {
        data: "master/api/kategori/rekomendasi/",
        preview: "master/api/kategori/rekomendasi/",
      },
      breadCrumb: [
        {
          label: "MASTER",
          link: "#",
          active: false,
        },
        {
          label: "KATEGORI REKOMENDASI",
          link: "#",
          active: true,
        },
      ],
      component: "datatable1",
    },
  ],
  model: [
    {
      name: "id",
      isPk: true,
      isForm: false,
      isTable: false,
    },
     {
      name: "kode",
      label: "Kode",
      type: "text",
      validation: {
        insert: [
          {
            required: true,
            message: " harus diisi",
          },
        ],
      },
      isForm: true,
      isTable: true,
    },
    {
      name: "nama",
      label: "Nama",
      type: "text",
      validation: {
        insert: [
          {
            required: true,
            message: " harus diisi",
          },
        ],
      },
      isForm: true,
      isTable: true,
    },
  ],
};
